import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";

import { NewsFeedItemPostEvent, NewsFeedItemRecommendationEvent } from "../types";

export function getNewsFeedContentLinkText(params: {
  event: NewsFeedItemPostEvent | NewsFeedItemRecommendationEvent;
  workerName?: string;
  referredWorkerName?: string;
  recommendedWorkerName?: string;
  workplaceName?: string;
  recommendedWorkplaceName?: string;
}) {
  const {
    event,
    workerName,
    referredWorkerName,
    recommendedWorkerName,
    workplaceName,
    recommendedWorkplaceName,
  } = params;

  switch (event) {
    case NewsFeedItemPostEvent.WORKER_RECEIVED_INSTANT_PAY:
    case NewsFeedItemRecommendationEvent.WORKPLACE_RECOMMENDATION: {
      return `Check out ${workplaceName ?? recommendedWorkplaceName ?? "the workplace"}`;
    }

    case NewsFeedItemPostEvent.WORKER_REVIEWED_WORKPLACE: {
      return `Check out ${workerName ?? "your friend"}'s review`;
    }

    case NewsFeedItemPostEvent.WORKER_BOOKED_SHIFT_AT_WORKPLACE_WITH_OPENINGS: {
      return `Check out ${workerName ?? "your friend"}'s shift`;
    }

    case NewsFeedItemPostEvent.REFERRED_NEW_WORKER_JOINED:
    case NewsFeedItemRecommendationEvent.FRIEND_RECOMMENDATION: {
      return `Add ${referredWorkerName ?? recommendedWorkerName ?? "them"} as a friend`;
    }

    default: {
      logError(APP_V2_APP_EVENTS.UNSUPPORTED_NEWS_FEED_EVENT, {
        error: "Unsupported news feed event",
        metadata: { event },
      });
      return "";
    }
  }
}
